import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const ProfileUserIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", {
    width: "58",
    height: "58",
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.83333 58C4.83333 58 0 58 0 53.1667C0 48.3333 4.83333 33.8333 29 33.8333C53.1667 33.8333 58 48.3333 58 53.1667C58 58 53.1667 58 53.1667 58H4.83333ZM29 29C32.8456 29 36.5338 27.4723 39.2531 24.753C41.9723 22.0338 43.5 18.3456 43.5 14.5C43.5 10.6544 41.9723 6.96623 39.2531 4.24695C36.5338 1.52767 32.8456 0 29 0C25.1544 0 21.4662 1.52767 18.747 4.24695C16.0277 6.96623 14.5 10.6544 14.5 14.5C14.5 18.3456 16.0277 22.0338 18.747 24.753C21.4662 27.4723 25.1544 29 29 29Z",
    fill: "#00475B"
  }));
};
export default ProfileUserIcon;